module.exports = {
  path: "screen",
  /*  getComponent(nextState, cb) {
    require.ensure([], require => {
      cb(null, require("./linyin"));
    });
  } */
  getChildRoutes(childStates, cb) {
    require.ensure([], require => {
      cb(null, [require("./home"), require("./details")]);
    });
  }
};
